"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: waitlist/waitlist-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fwaitlist%2Fwaitlist-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaitlistServiceClient = exports.GetEnlistmentsResponse = exports.GetEnlistmentsRequest = exports.EnlistResponse = exports.EnlistRequest = exports.IsWaitlistOpenedResponse = exports.IsWaitlistOpenedRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const waitlist_1 = require("./waitlist");
const protobufPackage = 'com.step.waitlist.proto';
function createBaseIsWaitlistOpenedRequest() {
    return { waitlistId: '' };
}
exports.IsWaitlistOpenedRequest = {
    fromJSON(object) {
        const message = {
            waitlistId: isSet(object.waitlistId) ? globalThis.String(object.waitlistId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.waitlistId !== '') {
            obj.waitlistId = message.waitlistId;
        }
        return obj;
    },
    create(base) {
        return exports.IsWaitlistOpenedRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIsWaitlistOpenedRequest();
        message.waitlistId = object.waitlistId ?? '';
        return message;
    },
};
function createBaseIsWaitlistOpenedResponse() {
    return { isOpened: false };
}
exports.IsWaitlistOpenedResponse = {
    fromJSON(object) {
        const message = {
            isOpened: isSet(object.isOpened) ? globalThis.Boolean(object.isOpened) : false,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.isOpened !== false) {
            obj.isOpened = message.isOpened;
        }
        return obj;
    },
    create(base) {
        return exports.IsWaitlistOpenedResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseIsWaitlistOpenedResponse();
        message.isOpened = object.isOpened ?? false;
        return message;
    },
};
function createBaseEnlistRequest() {
    return { waitlistId: '' };
}
exports.EnlistRequest = {
    fromJSON(object) {
        const message = {
            waitlistId: isSet(object.waitlistId) ? globalThis.String(object.waitlistId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.waitlistId !== '') {
            obj.waitlistId = message.waitlistId;
        }
        return obj;
    },
    create(base) {
        return exports.EnlistRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseEnlistRequest();
        message.waitlistId = object.waitlistId ?? '';
        return message;
    },
};
function createBaseEnlistResponse() {
    return {};
}
exports.EnlistResponse = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.EnlistResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseEnlistResponse();
        return message;
    },
};
function createBaseGetEnlistmentsRequest() {
    return {};
}
exports.GetEnlistmentsRequest = {
    fromJSON(_) {
        const message = {};
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return exports.GetEnlistmentsRequest.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseGetEnlistmentsRequest();
        return message;
    },
};
function createBaseGetEnlistmentsResponse() {
    return { enlistments: [] };
}
exports.GetEnlistmentsResponse = {
    fromJSON(object) {
        const message = {
            enlistments: globalThis.Array.isArray(object?.enlistments)
                ? object.enlistments.map((e) => waitlist_1.Enlistment.fromJSON(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.enlistments?.length) {
            obj.enlistments = message.enlistments.map((e) => waitlist_1.Enlistment.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetEnlistmentsResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetEnlistmentsResponse();
        message.enlistments = object.enlistments?.map((e) => waitlist_1.Enlistment.fromPartial(e)) || [];
        return message;
    },
};
class WaitlistServiceClient {
    rpc;
    name = 'com.step.waitlist.proto.WaitlistService';
    type = rpc_1.ServiceType.PUBLIC;
    path = '/waitlist';
    methods = [{
            name: 'IsWaitlistOpened',
            requestType: exports.IsWaitlistOpenedRequest,
            responseType: exports.IsWaitlistOpenedResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'Enlist',
            requestType: exports.EnlistRequest,
            responseType: exports.EnlistResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }, {
            name: 'GetEnlistments',
            requestType: exports.GetEnlistmentsRequest,
            responseType: exports.GetEnlistmentsResponse,
            authenticationOptions: { level: rpc_1.AuthLevel.LOW },
            adminTokenType: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Indicates whether a waitlist is opened.
     */
    isWaitlistOpened(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Enlist a user to a waitlist.
     */
    enlist(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[1],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
    /**
     * Get a list of active waitlists.
     */
    getEnlistments(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[2],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.WaitlistServiceClient = WaitlistServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=waitlist-service.js.map